<app-dialog-header titleTranslateKey="scheduler.setup.zone.new.title" (closeClicked)="cancel()">
</app-dialog-header>

<form (ngSubmit)="submit()" [formGroup]="newZoneForm">
  <mat-dialog-content class="fullscreen-dialog">

    <mat-form-field appearance="fill">
      <mat-label>Zone Name</mat-label>
      <input title="Name" formControlName="name" matInput type="text" [attr.aria-label]="'Zone Name'"
        [placeholder]="'Enter zone name'">
    </mat-form-field>


  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button [disabled]="newZoneForm.pristine || !newZoneForm.valid" color="primary" mat-raised-button type="submit">
      Begin Drawing
    </button>
  </mat-dialog-actions>
</form>